import React from 'react';
import PropTypes from 'prop-types';
import InputConsumer from '../InputConsumer';
import { st, classes } from './WsrIconAffix.st.css';
const IconAffix = ({ children, dataHook }) => (React.createElement(InputConsumer, { consumerCompName: IconAffix.displayName }, ({ size, inPrefix, inSuffix, border, disabled, onInputClicked }) => (React.createElement("div", { className: st(classes.root, {
        size,
        inPrefix,
        inSuffix,
        border,
        disabled,
    }), onClick: !disabled ? onInputClicked : undefined, "data-hook": dataHook }, React.cloneElement(children, {
    size: size === 'tiny' || size === 'small' ? '18px' : '24px',
})))));
IconAffix.displayName = 'Input.IconAffix';
IconAffix.propTypes = {
    children: PropTypes.element.isRequired,
    dataHook: PropTypes.string,
};
export default IconAffix;
//# sourceMappingURL=IconAffix.js.map